import SubcategoryPage from '@/components/template/SubcategoryPage';

const LeCuir = () => {
  const products = [
    {
      title: "Le Cuir Model 1",
      imageSrc: "https://images.unsplash.com/photo-1554302891-c04b1941b963?auto=format&fit=crop&q=80",
      url: "/ogledala/le-cuir/model-1"
    },
    {
      title: "Le Cuir Model 2",
      imageSrc: "https://images.unsplash.com/photo-1604014555037-e3abbf2d28b3?auto=format&fit=crop&q=80",
      url: "/ogledala/le-cuir/model-2"
    },
    {
      title: "Le Cuir Model 3",
      imageSrc: "https://images.unsplash.com/photo-1513519683267-4ee6636c0a3f?auto=format&fit=crop&q=80",
      url: "/ogledala/le-cuir/model-3"
    },
    {
      title: "Le Cuir Model 4",
      imageSrc: "https://images.unsplash.com/photo-1526579353087-90e96bdbd672?auto=format&fit=crop&q=80",
      url: "/ogledala/le-cuir/model-4"
    }
  ];

  return (
    <SubcategoryPage
      title="Le Cuir"
      description="Luksuzna ogledala z usnjenim okvirjem, ki dodajo toplino in teksturo vašemu prostoru. Francoska eleganca za zahtevne okuse."
      heroImage="https://images.unsplash.com/photo-1554302891-c04b1941b963?auto=format&fit=crop&q=80"
      products={products}
    />
  );
};

export default LeCuir;